import { NotificationManage } from "../../components/NotificationManage"
import Config from "../../config"
import ObjectGenerator from "../Function/CreateUserObjectGenerator"
import { API, graphqlOperation } from "aws-amplify"
import axios from "axios"
import { trackLogin } from "../../graphql/mutation"
import { handlelocalstorageSet } from "../Registration/PostMessage"
//////////////////////////////////////// GM

export async function handleClickGM({
	event,
	t,
	login_gm,
	handleClickClose,
	mobile,
	create_user,
	get_user,
	update_latest_login,
	history
}) {
	event.preventDefault()
	if (localStorage.getItem("UsedCookie") === "true") {
		const ga = window.gapi.auth2.getAuthInstance()
		ga.signIn()
			.then(async (googleUser) => {
				login_gm(googleUser)
					.then((res) => {
						get_user(res.value.response.data.IdentityId, res.value.response)
							.then(async (responses) => {
								if (Object.keys(responses.value).length === 0) {
									await create_user(
										ObjectGenerator({ ...res.value.result }, "GOOGLE")
									)
									await get_user(
										res.value.response.data.IdentityId,
										res.value.response
									)
									history.push("/signup_success")
								}
								!mobile && handleClickClose()
								axios
									.get("https://extreme-ip-lookup.com/json/")
									.then(async (data) => {
										await API.graphql(
											graphqlOperation(
												trackLogin(
													JSON.stringify(data.data).replace(/"/g, '\\"')
												)
											)
										)
									})
									.catch((err) => {})
								await update_latest_login()
								handlelocalstorageSet()
								NotificationManage(
									"success",
									`Welcome ${res.value.result.given_name} ${res.value.result.family_name}`,
									"Login success"
								)
							})
							.catch((e) => {
								NotificationManage("error", "Login", "Failure")
							})
					})
					.catch((e) => {
						NotificationManage("error", "Login", "Failure")
						!mobile && handleClickClose()
					})
			})
			.catch((e) => {
				NotificationManage("error", "Login", "Failure")
			})
	} else {
		NotificationManage(
			"info",
			`${t("NotificationManager.Login.You")}`,
			`${t("NotificationManager.status.info")}`
		)
	}
}

///////////////////////////////////////////////

//////////////////////////////////////// FB

export async function handleClickFB({
	event,
	t,
	login_fb,
	handleClickClose,
	mobile,
	create_user,
	get_user,
	update_latest_login,
	history
}) {
	event.preventDefault()
	if (localStorage.getItem("UsedCookie") === "true") {
		const fb = window.FB
		await fb.getLoginStatus((response) => {
			if (response.status === "connected") {
				login_fb(response.authResponse)
					.then((res) => {
						get_user(res.value.response.data.IdentityId, res.value.response)
							.then(async (responses) => {
								if (Object.keys(responses.value).length === 0) {
									await create_user(
										ObjectGenerator({ ...res.value.result }, "FACEBOOK")
									)
									await get_user(
										res.value.response.data.IdentityId,
										res.value.response
									)
									history.push("/signup_success")
								}
								!mobile && handleClickClose()
								axios
									.get("https://extreme-ip-lookup.com/json/")
									.then(async (data) => {
										await API.graphql(
											graphqlOperation(
												trackLogin(
													JSON.stringify(data.data).replace(/"/g, '\\"')
												)
											)
										)
									})
									.catch((err) => {})
								await update_latest_login()
								handlelocalstorageSet()
								NotificationManage(
									"success",
									`Welcome ${res.value.result.first_name} ${res.value.result.last_name}`,
									"Login success"
								)
							})
							.catch((err) => {})
					})
					.catch((e) => {
						NotificationManage("error", "Login", "Failure")
					})
			} else {
				fb.login(
					(response) => {
						if (!response || !response.authResponse) {
							return
						}
						login_fb(response.authResponse)
							.then((res) => {
								get_user(res.value.response.data.IdentityId, res.value.response)
									.then(async (responses) => {
										if (Object.keys(responses.value).length === 0) {
											await create_user(
												ObjectGenerator({ ...res.value.result }, "FACEBOOK")
											)
											await get_user(
												res.value.response.data.IdentityId,
												res.value.response
											)
											history.push("/signup_success")
										}
										!mobile && handleClickClose()
										axios
											.get("https://extreme-ip-lookup.com/json/")
											.then(async (data) => {
												await API.graphql(
													graphqlOperation(
														trackLogin(
															JSON.stringify(data.data).replace(/"/g, '\\"')
														)
													)
												)
											})
											.catch((err) => {})
										await update_latest_login()
										handlelocalstorageSet()
										NotificationManage(
											"success",
											`Welcome ${res.value.result.first_name} ${res.value.result.last_name}`,
											"Login success"
										)
									})
									.catch((err) => {})
							})
							.catch((e) => {
								NotificationManage("error", "Login", "Failure")
							})
					},
					{
						scope: "public_profile,email"
					}
				)
			}
		})
	} else {
		NotificationManage(
			"info",
			`${t("NotificationManager.Login.You")}`,
			`${t("NotificationManager.status.info")}`
		)
	}
}

///////////////////////////////////////////////

//////////////////////////////////////// LN

export async function handleClickLN({
	event,
	t,
	login_ln,
	handleClickClose,
	mobile,
	create_user,
	get_user,
	update_latest_login,
	history
}) {
	event.preventDefault()
	if (localStorage.getItem("UsedCookie") === "true") {
		const webAuth = Config.auth.social.webAuth0
		await webAuth.authorize({ connection: "linkedin" })
	} else {
		NotificationManage(
			"info",
			`${t("NotificationManager.Login.You")}`,
			`${t("NotificationManager.status.info")}`
		)
	}
}
